import * as React from 'react'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog'
import { MoreHorizontal, RotateCcw, Mail, HatGlasses, UserX, Eye, Pencil } from 'lucide-react'
import { useDispatch, useSelector } from 'react-redux'
// @ts-expect-error JS selector, no types provided
import { getJwtToken } from '../../userContext/userContext.selectors'
// @ts-expect-error JS slice, no types provided
import { actions } from '../../Customers/customers.slice'
// @ts-expect-error JS constants, no types provided
import { CUSTOMER_MODALS } from '../../Customers/customers.constants'
// @ts-expect-error JS selector, no types provided
import { selectIsAdmin } from '../../Profile/profile.selectors'
// @ts-expect-error JS slice, no types provided
import { actions as notificationActions } from '../../../infrastructure/notificationPopup/notificationPopup.slice'
const { setSelectedCustomerModal } = actions
const { notifyError } = notificationActions

const { setSelectedRow } = actions
type UserLike = { id?: string; userName?: string; name?: string; email?: string; lastLogin?: string | null }

type UserActionsProps = {
    user: UserLike
    onView?: (user: UserLike) => void
    onEdit?: (user: UserLike) => void
    onResetPassword?: (user: UserLike) => void
    onDelete?: (user: UserLike) => Promise<void> | void
}

export default function UserActions({ user }: UserActionsProps) {
    const jwtToken = useSelector(getJwtToken)
    const isAdmin = useSelector(selectIsAdmin) as boolean
    const dispatch = useDispatch()
    const isInvite = !user.lastLogin

    const handleResetPassword = () => {
        dispatch(setSelectedRow(user))
        dispatch(setSelectedCustomerModal(CUSTOMER_MODALS.RESET_CUSTOMER_USER_PASSWORD))
    }
    const handleImpersonate = () => {
        const url = import.meta.env.VITE_E4473_URL
        if (user?.id && jwtToken && url) {
            try {
                window.open(`${url}?token=${jwtToken}&id=${user.id}`, '_blank')
            } catch {
                dispatch(notifyError('Something went wrong. Unable to impersonate.'))
            }
        } else {
            dispatch(notifyError('Something went wrong. Unable to impersonate.'))
        }
    }
    const handleDelete = async () => {
        dispatch(setSelectedRow(user))
        dispatch(setSelectedCustomerModal(CUSTOMER_MODALS.DELETE_USER_MODAL))
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant='ghost' className='h-8 w-8 p-0'>
                    <span className='sr-only'>Open menu</span>
                    <MoreHorizontal />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align='start'>
                <DropdownMenuLabel>User Actions</DropdownMenuLabel>
                <DropdownMenuSeparator />
                {/* <DropdownMenuItem onClick={handleView}> <Eye className='w-4 h-4 mr-2' /> View</DropdownMenuItem>
                <DropdownMenuItem onClick={handleEdit}> <Pencil className='w-4 h-4 mr-2' /> Edit</DropdownMenuItem>
                <DropdownMenuSeparator /> */}
                <DropdownMenuItem onClick={handleResetPassword}>
                    {isInvite
                        ? <><Mail className='w-4 h-4 mr-2' /> Resend Invitation</>
                        : <><RotateCcw className='w-4 h-4 mr-2' /> Reset Password</>
                    }
                </DropdownMenuItem>
                {isAdmin && (
                    <DropdownMenuItem onClick={handleImpersonate}>
                        <HatGlasses className='w-4 h-4 mr-2' /> Impersonate
                    </DropdownMenuItem>
                )}
                {isAdmin && (
                    <AlertDialog>
                        <AlertDialogTrigger asChild>
                            <DropdownMenuItem
                                className='text-destructive focus:text-destructive'
                                onSelect={(e) => e.preventDefault()}
                            >
                                <UserX className='w-4 h-4 mr-2' /> Delete User
                            </DropdownMenuItem>
                        </AlertDialogTrigger>
                        <AlertDialogContent>
                            <AlertDialogHeader>
                                <AlertDialogTitle>Delete user?</AlertDialogTitle>
                                <AlertDialogDescription>
                                    This action cannot be undone.
                                </AlertDialogDescription>
                            </AlertDialogHeader>
                            <AlertDialogFooter>
                                <AlertDialogCancel>Cancel</AlertDialogCancel>
                                <AlertDialogAction onClick={handleDelete}>Confirm</AlertDialogAction>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialog>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}


